import { IoMdOpen } from "react-icons/io";
import { TypeCard } from "../../../Pages/Brand/DashBoard/Discover/DashBoard";
import { HiFire } from "react-icons/hi";

export const CreatorDetailCard = ({
  icon,
  heading,
  proofLink,
  count,
  data,
  bg,
}) => {
  if (count < 10) {
    count = count;
  } else if (count < 100) {
    count = Math.floor(count / 10) * 10;
  } else {
    count = Math.floor(count / 100) * 100;
  }
  return (
    <>
      {heading && heading !== "NONE" && (
        <div
          style={{
            background: bg,
            boxShadow: "4px 4px 8px 0px rgba(136, 136, 136, 0.10)",
          }}
          className={`w-full md:w-[280px] p-[12px]  flex flex-col border-[1px] border-[#E0E0E0]  rounded-[10px]`}
        >
          <div className="flex items-center justify-between">
            <div className="w-[40px] h-[40px] rounded-[50%] overflow-hidden">
              <img src={icon} alt="" />
            </div>

            <div
              onClick={() => {
                if (!/^https?:\/\//i.test(proofLink)) {
                  const link = "https://" + proofLink;
                  return window.open(link, "_blank");
                }

                window.open(proofLink, "_blank");
              }}
              className="flex items-center cursor-pointer justify-center gap-[10px] py-[4px] px-[11px] rounded-[6px] bg-[#FAFAFA] text-[#FF5C5C] text-[10px]"
            >
              PROOF <IoMdOpen />
            </div>
          </div>
          <div className="w-full mt-[20px] mb-[16px] align-start text-[12px] font-inter text-[#424242] font-[700] ">
            {heading}
          </div>
          <div
            style={{ rowGap: "10px" }}
            className="w-full flex flex-wrap gap-[8px] "
          >
            {data?.map((item) => {
              return (
                <TypeCard
                  item={item}
                  Objkey={undefined}
                  borderRadius={"6px"}
                  locked={undefined}
                  LinkObjKey={undefined}
                  subItem={undefined}
                  bg={"rgba(250, 250, 250, 0.50)"}
                />
              );
            })}
          </div>
          {count > 1 && (
            <div className="w-full h-full mt-[20px] mb-[16px] items-end  flex justify-end text-[12px] font-inter text-[#FF5C5C] font-[400] ">
              <div className="flex items-center gap-[4px] text-[12px] rounded-[6px] bg-[#FAFAFA] px-[4px] py-[8px] ">
                <HiFire size={16} /> {count}+ Purchased
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export const CreatorSocialCard = ({ bg, logo, users, Socialtype }) => {
  return (
    <>
      {Socialtype && (
        <div
          style={{ boxShadow: "4px 4px 8px 0px rgba(136, 136, 136, 0.10)" }}
          className={`w-[156px] md:w-[160px] gap-[10px] py-[20px] flex flex-col items-center justify-center rounded-[16px] ${bg}`}
        >
          <div className="flex flex-col text-[10px] font-[400] text-[#757575] gap-[8px] items-center justify-center ">
            <img className="w-[40px]  h-[40px] " src={logo} alt="" />
            <p>{Socialtype?.toUpperCase()}</p>
          </div>

          <p className=" text-[20px]  font-[700] font-Inter  ">{users}</p>
          <p className="text-[16px] font-[400] text-[#757575]">FOLLOWERS</p>
        </div>
      )}
    </>
  );
};
export const CreatorSocialCard2 = ({ bg, logo, users, Socialtype }) => {
  return (
    <>
      {Socialtype && (
        <div
          style={{ boxShadow: "4px 4px 8px 0px rgba(136, 136, 136, 0.10)" }}
          className={`w-[266px] md:w-[266px] gap-[20px] py-[12px] px-[20px] flex flex-col items-start justify-start rounded-[8px] ${bg}`}
        >
          <div className="flex text-[10px] font-[400] text-[#757575] gap-[4px] items-center justify-center ">
            <img className="flex w-[24px]  h-[24px] " src={logo} alt="" />
            <div className="flex items-center justify-center">
              {Socialtype?.toUpperCase()}
            </div>
          </div>
          <div className="flex items-center justify-center gap-[8px]">
            <p className=" flex text-[16px]  font-[700] font-Inter text-[#424242]  ">
              {users}
            </p>
            <p className="flex text-[12px] font-[400] text-[#757575]">
              Followers
            </p>
          </div>
        </div>
      )}
    </>
  );
};
